import React from 'react';
import { Link } from 'react-router-dom';
import LegalLayout, { LegalSection, LegalDisclaimer, LegalLastUpdated } from '../LegalLayout';
import { APP_NAME } from '../../config/branding';

export default function SafetyReportPage() {
  return (
    <LegalLayout
      title="Safety & Reporting"
      subtitle={`How to report harmful content, abuse, and safety concerns on ${APP_NAME}.`}
    >
      <LegalLastUpdated />

      <LegalSection title="Your safety matters">
        <p>
          If you or someone else is in immediate danger, contact local emergency services first. {APP_NAME} is not an
          emergency response service. After ensuring immediate safety, you can report concerns to us using the methods
          below.
        </p>
      </LegalSection>

      <LegalSection title="What you can report">
        <ul>
          <li>Harassment, threats, or hate directed at individuals or groups</li>
          <li>Content sexualizing or exploiting minors (reported urgently to us and authorities where required)</li>
          <li>Non-consensual intimate imagery</li>
          <li>Spam, scams, phishing, or impersonation</li>
          <li>Copyright or trademark infringement</li>
          <li>Posts, comments, stories, club content, or media that violate our{' '}
            <Link to="/legal/code-of-conduct" className="legal-inline-link">Code of Conduct</Link></li>
          <li>Self-harm or suicide content — we may provide resources and restrict harmful material</li>
        </ul>
      </LegalSection>

      <LegalSection title="How to report">
        <p><strong>In the app:</strong> Use report or flag controls on posts, comments, profiles, or messages where available.</p>
        {/* <p><strong>By email:</strong> Send details to{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="legal-inline-link">{SUPPORT_EMAIL}</a> with subject line
          &quot;Safety Report&quot;.</p> */}
        <p><strong>Contact form:</strong> Use our <Link to="/contact" className="legal-inline-link">Contact</Link> page
          and describe the issue. Attach screenshots or files if helpful (within size limits).</p>
      </LegalSection>

      <LegalSection title="What to include">
        <ul>
          <li>Direct links to the content or profile (URLs)</li>
          <li>Usernames or handles involved (personal or social profile if known)</li>
          <li>Date and time you observed the issue</li>
          <li>A clear description of why the content violates our policies</li>
          <li>Any additional context (e.g., pattern of behavior across multiple posts)</li>
        </ul>
      </LegalSection>

      <LegalSection title="What happens after you report">
        <p>
          Reports are reviewed by our moderation team according to severity and available resources. We may remove content,
          warn users, restrict features, or suspend accounts. Not every report results in removal — we assess each case
          against our policies. We generally cannot share detailed outcomes about other users&apos; accounts due to privacy
          obligations.
        </p>
        <p>
          {APP_NAME} does not guarantee that all harmful content will be detected proactively. Community reports are an
          essential part of keeping the platform safe.
        </p>
      </LegalSection>

      <LegalSection title="Blocking and muting">
        <p>
          Where available, use block, mute, or unfollow tools to limit unwanted interactions. These personal controls
          complement platform moderation but do not replace reporting serious violations.
        </p>
      </LegalSection>

      <LegalSection title="False or abusive reporting">
        <p>
          Submitting false or bad-faith reports to harass others may itself violate our policies and lead to action
          against the reporting account.
        </p>
      </LegalSection>

      <LegalDisclaimer />
    </LegalLayout>
  );
}
